import {
  Box, Skeleton, Button, useTheme,
} from '@mui/material';

export function WalletRewardsBalanceCardSkeleton() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        padding: theme.spacing(3.125),
        width: '100%',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(3.125),
        borderRadius: theme.spacing(1.5),
        border: `1px solid ${theme.palette.grey[200]}`,
      }}
    >
      <Skeleton animation="wave" height={24} width="50%" />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: theme.spacing(3),
        }}
      >
        <Box sx={{
          display: 'flex', flexDirection: 'column', gap: theme.spacing(1.25), width: '100%',
        }}>
          <Skeleton animation="wave" height={32} width="70%" />
          <Skeleton animation="wave" height={20} width="50%" />
          <Skeleton animation="wave" height={20} width="60%" />
        </Box>
        <Skeleton
          variant="rectangular"
          animation="wave"
          height={80}
          width={80}
          sx={{ borderRadius: theme.spacing(1) }}
        />
      </Box>
      <Button
        fullWidth
        disabled
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: theme.spacing(1),
          padding: theme.spacing(2, 1, 2, 1.5),
          borderRadius: theme.spacing(3),
        }}
      >
        <Skeleton animation="wave" height={24} width="50%" />
      </Button>
    </Box>
  );
}
